<template>
  <div>
    <div style="float: none" id="allLoginName">
    </div>
  </div>
</template>

<script>
export default {
  name: 'allLoginName',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
  span{
    padding: 3px 20px;
    border-radius: 5px;
    margin-right: 5px;
  }
  .userDownLoad{
    display: inline-block;
    margin-right: 20px;
    color: #FF7F41;
  }
  #allLoginName{
    display: inline-block;
    position: relative;
    padding: 20px;
    z-index: 16;
  }
  #allLoginName:hover #chooseNowApp{
    display: block;
  }
  #chooseNowApp{
    position: absolute;
    background-color: #fff;
    border-radius: 5px;
    top: 50px;
    width: 140px;
    z-index: 5;
    display: none;
  }
  #chooseNowApp > div{
    padding: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  #chooseNowApp > div:hover{
    background: #EFA868;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/allLoginName.vue